/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchCustomRolePathParams = NonNullable<operations['patchCustomRole']['parameters']['path']>;

export type PatchCustomRoleRequestBody = OperationRequestBodyContent<operations['patchCustomRole']>;

export interface Input extends PatchCustomRolePathParams {
  apiVersion?: string;
  body: PatchCustomRoleRequestBody;
}

export async function patchCustomRole(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/roles/{customRoleKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
